import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalAngebotsIdReceivedAction,
} from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';

export const angebotsIdReducer = function (
  sectionState: IAppState['angebotsId'] = '',
  action: AnyAction,
): IAppState['angebotsId'] {
  switch (action.type) {
    case GlobalActions.ANGEBOTS_ID_RECEIVED:
      return (action as GlobalAngebotsIdReceivedAction).payload;
    default:
      return sectionState;
  }
};
